export default __webpack_public_path__ + "static/media/Clap2.13b78ea3.svg";